import m from "./index.es150.js";
import a from "./index.es155.js";
import b from "./index.es144.js";
const g = (r, e) => {
  const { length: f } = r = r ? r.filter(Boolean) : [];
  if (e || f) {
    let i = new AbortController(), c;
    const o = function(n) {
      if (!c) {
        c = !0, l();
        const t = n instanceof Error ? n : this.reason;
        i.abort(t instanceof a ? t : new m(t instanceof Error ? t.message : t));
      }
    };
    let s = e && setTimeout(() => {
      s = null, o(new a(`timeout ${e} of ms exceeded`, a.ETIMEDOUT));
    }, e);
    const l = () => {
      r && (s && clearTimeout(s), s = null, r.forEach((n) => {
        n.unsubscribe ? n.unsubscribe(o) : n.removeEventListener("abort", o);
      }), r = null);
    };
    r.forEach((n) => n.addEventListener("abort", o));
    const { signal: u } = i;
    return u.unsubscribe = () => b.asap(l), u;
  }
};
export {
  g as default
};
//# sourceMappingURL=index.es358.js.map
